import React from "react";

/* 일정 생성 플로우 진행 표시 — 4단계, 라벨 상시 노출
   App.js가 플로우 화면(personal/travel/generating/result)에서만 렌더한다 */
export default function StepDots({ current, darkMode, lang, onStepClick }) {
  const steps = [
    { key: "personal",   ko: "내 정보",  en: "Profile" },
    { key: "travel",     ko: "여행 조건", en: "Trip" },
    { key: "generating", ko: "AI 생성",  en: "AI" },
    { key: "result",     ko: "일정",     en: "Plan" },
  ];
  const currentKey = current === "review" ? "result" : current;
  const activeIdx = Math.max(0, steps.findIndex((s) => s.key === currentKey));

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "14px 8px 4px",
        marginBottom: 10,
      }}
    >
      {steps.map((step, i) => {
        const isActive = i === activeIdx;
        const isDone = i < activeIdx;
        const canNav = isDone && step.key !== "generating";

        return (
          <React.Fragment key={step.key}>
            {i > 0 && (
              <div
                style={{
                  flex: 1,
                  maxWidth: 40,
                  height: 2.5,
                  borderRadius: 2,
                  marginTop: 15,
                  background: i <= activeIdx
                    ? "linear-gradient(90deg, #6366F1, #8B5CF6)"
                    : darkMode
                    ? "rgba(255,255,255,0.12)"
                    : "rgba(15,23,42,0.08)",
                  transition: "background 0.4s ease",
                }}
              />
            )}
            <button
              onClick={() => canNav && onStepClick && onStepClick(step.key)}
              disabled={!canNav}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 5,
                background: "none",
                border: "none",
                padding: "0 6px",
                cursor: canNav ? "pointer" : "default",
                fontFamily: "inherit",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <div
                className="text-sm"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 800,
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  background: isActive
                    ? "linear-gradient(135deg, #6366F1, #8B5CF6)"
                    : isDone
                    ? darkMode ? "rgba(45,212,191,0.18)" : "rgba(20,184,166,0.12)"
                    : darkMode
                    ? "rgba(255,255,255,0.07)"
                    : "rgba(15,23,42,0.05)",
                  color: isActive
                    ? "#FFFFFF"
                    : isDone
                    ? darkMode ? "#2DD4BF" : "#0D9488"
                    : darkMode
                    ? "rgba(255,255,255,0.4)"
                    : "rgba(15,23,42,0.35)",
                  border: isDone ? `1.5px solid ${darkMode ? "rgba(45,212,191,0.4)" : "rgba(20,184,166,0.35)"}` : "1.5px solid transparent",
                  boxShadow: isActive ? "0 4px 12px rgba(99, 102, 241, 0.35)" : "none",
                  transform: isActive ? "scale(1.08)" : "scale(1)",
                }}
              >
                {isDone ? "✓" : i + 1}
              </div>
              <span
                className="text-xs"
                style={{
                  fontWeight: isActive ? 800 : 600,
                  whiteSpace: "nowrap",
                  color: isActive
                    ? darkMode ? "#A5B4FC" : "#4F46E5"
                    : isDone
                    ? darkMode ? "rgba(45,212,191,0.8)" : "rgba(13,148,136,0.8)"
                    : darkMode
                    ? "rgba(255,255,255,0.38)"
                    : "rgba(15,23,42,0.38)",
                  transition: "color 0.3s",
                }}
              >
                {lang === "ko" ? step.ko : step.en}
              </span>
            </button>
          </React.Fragment>
        );
      })}
    </div>
  );
}
